export const LATEX_ENTITIES = {
  copyright: '©',
  textcopyright: '©',
  dag: '†',
  textdagger: '†',
  ddag: '‡',
  textdaggerdbl: '‡',
  guillemotleft: '«',
  guillemotright: '»',
  guilsinglleft: '‹',
  guilsinglright: '›',
  ldots: '…',
  dots: '…',
  textellipsis: '…',
  lq: '‘',
  P: '¶',
  textparagraph: '¶',
  pounds: '£',
  textsterling: '£',
  quotedblbase: '„',
  quotesinglbase: '‚',
  rq: '’',
  S: '§',
  sim: '~',
  textasciicircum: '^',
  textasciitilde: '˜',
  texttildelow: '~',
  textasteriskcentered: '*',
  textbackslash: '\'',
  textbar: '|',
  textbardbl: '╎',
  textbigcircle: '◯',
  textbraceleft: '{',
  textbraceright: '}',
  textbullet: '•',
  textdollar: '$',
  textemdash: '—',
  textendash: '—',
  texteuro: '€',
  eurosym: '€',
  euro: '€',
  textexclamdown: '¡',
  textgreater: '>',
  textless: '<',
  textordfeminine: 'ª',
  textordmasculine: 'º',
  textperiodcentered: '·',
  cdot: '·',
  textquestiondown: '¿',
  textquotedblleft: '“',
  textquotedblright: '”',
  textquoteleft: '‘',
  textquoteright: '’',
  textquotestraightbase: '‚',
  textquotestraightdblbase: '„',
  textregistered: '®',
  textthreequartersemdash: '-', // between en-dash and em-dash.
  texttrademark: '™',
  texttwelveudash: '-', // between en-dash and em-dash.
  textunderscore: '_',
  textvisiblespace: '␣',

  gets: '←',
  textleftarrow: '←',
  to: '→',
  textrightarrow: '→',

  textdegree: '°',

  infty: '∞',
  triangle: '△',
  triangledown: '▽',
  blacktriangle: '▲',
  blacktriangledown: '▼',
  angle: '∠',
  sphericalangle: '∢',
  aleph: 'ℵ',
  hbar: 'ħ',
  imath: '𝚤',
  jmath: '𝚥',
  ell: 'ℓ',
  wp: '℘',
  Re: 'ℜ',
  Im: 'ℑ',
  mho: '℧',
  prime: '′',
  emptyset: '∅',
  nabla: '∇',
  surd: '√',
  partial: '∂',
  top: '⟙',
  bot: '⟂',
  vdash: '⟝',
  dashv: '⟞',
  forall: '∀',
  exists: '∃',
  nexists: '∄',
  neg: '¬',
  lnot: '¬',
  flat: '♭',
  natural: '♮',
  sharp: '♯',
  backslash: '\\',
  Box: '□',
  Diamond: '♢',
  clubsuit: '♣',
  diamondsuit: '♦',
  heartsuit: '♥',
  spadesuit: '♠',
  Join: '⨝',
  blacksquare: '■',
  bigstar: '★',

  diagdown: '╲',
  diagup: '╱',
  blacklozenge: '⧫',

  rfloor: '⌋',
  lfloor: '⌊',
  rceil: '⌉',
  lceil: '⌈',
  rangle: '⟩',
  langle: '⟨',

  sum: '∑',
  int: '∫',
  oint: '∮',
  prod: '∏',
  coprod: '∏',
  bigcap: '∩',
  bigcup: '∪',
  bigsqcup: '⊔',
  bigvee: '∨',
  bigwedge: '∧',
  bigodot: '⊙',
  bigotimes: '⊗',
  bigoplus: '⊕',
  biguplus: '⊎',

  alpha: 'α',
  beta: 'β',
  chi: 'χ',
  delta: 'δ',
  epsilon: 'ε',
  eta: 'η',
  gamma: 'γ',
  iota: 'ι',
  kappa: 'κ',
  lambda: 'λ',
  mu: 'μ',
  nu: 'ν',
  omega: 'ω',
  phi: 'φ',
  pi: 'π',
  psi: 'ψ',
  rho: 'ρ',
  sigma: 'σ',
  tau: 'τ',
  theta: 'θ',
  upsilon: 'υ',
  xi: 'ξ',
  zeta: 'ζ',
  Alpha: 'Α',
  Beta: 'Β',
  Chi: 'Χ',
  Delta: 'Δ',
  Epsilon: 'Ε',
  Eta: 'Η',
  Gamma: 'Γ',
  Iota: 'Ι',
  Kappa: 'Κ',
  Lambda: 'Λ',
  Mu: 'Μ',
  Nu: 'Ν',
  Omega: 'Ω',
  Phi: 'Φ',
  Pi: 'Π',
  Psi: 'Ψ',
  Rho: 'Ρ',
  Sigma: 'Σ',
  Tau: 'Τ',
  Theta: 'Θ',
  Upsilon: 'Υ',
  Xi: 'Ξ',
  Zeta: 'Ζ',

  aa: 'å',
  AA: 'Å',
  ae: 'æ',
  AE: 'Æ',
  dh: 'ð',
  DH: '\u00D0',
  dj: 'đ',
  DJ: '\u0110',
  ij: '\u0133',
  IJ: '\u0132',
  l: 'ł',
  L: 'Ł',
  ng: 'ŋ',
  NG: 'Ŋ',
  o: 'ø',
  O: 'Ø',
  oe: 'œ',
  OE: 'Œ',
  ss: 'ß',
  SS: 'SS',
  th: 'þ',
  TH: 'Þ'
};
